import { call, put, takeEvery } from 'redux-saga/effects';
import { findIndex } from 'lodash';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';
import store from '../../store';

const getAccount = item => {
  if (item.is_admin && item.is_owner) return 'Admin (owner)';
  else if (item.is_admin) return 'Admin';
  else if (item.is_owner) return 'Owner';
  else return 'Member';
};

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.id,
      id: item.id,
      email: item.email,
      first_name: item.first_name,
      last_name: item.last_name,
      full_name: { first_name: item.first_name, last_name: item.last_name },
      last_login: item.last_login,
      account: getAccount(item),
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getMembers({ payload: { signal, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.members.get, params: { page: curr_page }, signal });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getMembersDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getMembersFailed,
      endpoint: api.members.get.url
    });
  }
}

function* deleteMember({ payload: { values, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.members.delete, id: values.id });

    const updated = [...getState().members.listData.dataTable];
    const deleteIndex = findIndex(updated, x => x.id === values.id);

    if (deleteIndex !== -1) {
      updated.splice(deleteIndex, 1);

      const preparedData = {
        dataTable: prepareDataTable(updated)
      };

      dispatch(actions.getMembersDone(preparedData));
    }

    onSuccess && onSuccess();
    yield put(actions.deleteMemberDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteMemberFailed,
      endpoint: api.members.delete.url
    });
  }
}

export const getMembersSaga = takeEvery(types.GET_MEMBERS_REQUEST, getMembers);
export const deleteMemberSaga = takeEvery(types.DELETE_MEMBER_REQUEST, deleteMember);